const templates = [
    {
      id: "wishlist-link",
      data: "wishlist",
      template: `
        <a href="{{ wishlist.url }}" class="wk-link wk-link--{{ wishlist.state }}" title="{{ locale.view_wishlist }}">
          <div class="wk-icon wk-link__icon">{% include "wishlist-icon" %}</div>
          <span class="wk-link__label">{{ locale.wishlist }}</span>
          <span class="wk-link__count">{{ wishlist.item_count }}</span>
        </a>
      `,
    },
    {
      id: "wishlist-button",
      data: "product",
      events: {
        "click button[data-wk-add-product]": (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          const variantInput = document.querySelector("form *[name='id']");
          const variantId = variantInput ? variantInput.value : undefined;
  
          WishlistKing.toolkit.addProduct(
            event.currentTarget.getAttribute("data-wk-add-product"),
            variantId
          );
        },
        "click button[data-wk-remove-product]": (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          WishlistKing.toolkit.removeProduct(
            event.currentTarget.getAttribute("data-wk-remove-product")
          );
        },
        "click button[data-wk-remove-item]": (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          WishlistKing.toolkit.removeItem(
            event.currentTarget.getAttribute("data-wk-remove-item")
          );
        },
      },
      template: `
        {% if product.in_wishlist %}
          {% assign btn_text = locale.in_wishlist %}
          {% assign btn_title = locale.remove_from_wishlist %}
          {% assign btn_action = 'remove' %}
        {% else %}
          {% assign btn_text = locale.add_to_wishlist %}
          {% assign btn_title = locale.add_to_wishlist %}
          {% assign btn_action = 'add' %}
        {% endif %}
  
        {% assign scope = "product" %}
        {% assign targetId = product.id %}
        {% assign icon_name = "wishlist-icon" %}
  
        {% if itemId %}
        {% assign scope = "item" %}
        {% assign targetId = itemId %}
        {% assign icon_name = "remove-icon" %}
        {% endif %}
  
        <button type="button" class="wk-button wk-button--{{ btn_action }} {{ addClass }}" title="{{ btn_title }}" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">
          <div class="wk-icon wk-button__icon">{% include icon_name %}</div>
          <span class="wk-button__label">{{ btn_text }}</span>
        </button>
      `,
    },
    {
      id: "wishlist-button-floating",
      data: "product",
      template: `
        {% include "wishlist-button" addClass: "wk-button--floating" %}
      `,
    },
    {
      id: "wishlist-page",
      data: "wishlist",
      events: {
        "click a[data-wk-share]": (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          WishlistKing.toolkit.requestWishlistSharing({
            wkShareService: event.currentTarget.getAttribute(
              "data-wk-share-service"
            ),
            wkShare: event.currentTarget.getAttribute("data-wk-share"),
            wkShareImage: event.currentTarget.getAttribute("data-wk-share-image"),
          });
        },
      },
      template: `
        <div class='wk-page {% if wishlist.read_only %}wk-page--shared{% endif %}'>
        {% if wishlist.item_count == 0 %}
  
            <div class="wk-note wk-note__list-empty">
              <p>{{ locale.wishlist_empty_note }}</p>
            </div>
  
        {% else %}
  
          {% if customer_accounts_enabled and customer == null and wishlist.read_only == false %}
            <div class="wk-note wk-note__login">
              <p>{{ locale.login_or_signup_note }}</p>
            </div>
          {% endif %}
  
          <div>
            <div class="wk-grid">
              {% assign item_count = 0 %}
              {% assign products = wishlist.products | reverse %}
              {% for product in products %}
                {% assign item_count = item_count | plus: 1 %}
                {% unless limit and item_count > limit %}
                  {% assign hide_default_title = false %}
                  {% if product.variants.length == 1 and product.variants[0].title contains 'Default' %}
                    {% assign hide_default_title = true %}
                  {% endif %}
  
                  {% assign variant = product.selected_or_first_available_variant %}
                  {% if variant.price < variant.compare_at_price %}
                    {% assign onsale = true %}
                  {% else %}
                    {% assign onsale = false %}
                  {% endif %}
                  <div>
                    <div class="wk-grid__item {% if onsale %}wk-product--sale{% endif %}" data-wk-item="{{ product.wishlist_item_id }}">
                      {% unless wishlist.read_only %}
                        {% include "wishlist-button-floating" itemId: product.wishlist_item_id %}
                      {% else %}
                        {% include "wishlist-button-floating" product: product %}
                      {% endunless %}
  
                      <a href="{{ product | variant_url }}" class="wk-product-image" title="{{ locale.view_product }}" style="background-image: url({{ product | variant_img_url: '1000x' }})"></a>
  
                      <div class="wk-product-info">
                        <a class="wk-product-title" href="{{ product | variant_url }}">
                          {{ product.title }}
                        </a>
                        <div class="wk-product-price">
                          <span class="wk-product-price--current">{{ variant.price | money }}</span>
                          <span class="wk-product-price--compare">{{ variant.compare_at_price | money }}</span>
                        </div>
                      </div>
  
                      {% include "wishlist-product-form" %}
                    </div>
                  </div>
                {% endunless %}
              {% endfor %}
            </div>
          </div>
  
          {% comment %}
          {% include "wishlist-button-bulk-add-to-cart" %}
          {% endcomment %}
  
          {% comment %}
          {% unless wishlist.read_only %}
            {% include "wishlist-button-clear" %}
          {% endunless %}
          {% endcomment %}
  
          {% unless wishlist.read_only %}
            <div class="wk-sharing">
              <h4 class="wk-title">{{ locale.share_wishlist }}</h4>
              <ul class="wk-sharing__list">
                <li class="wk-sharing__list-item">{% include "wishlist-share-button-fb" %}</li>
                <li class="wk-sharing__list-item">{% include "wishlist-share-button-twitter" %}</li>
                <li class="wk-sharing__list-item">{% include "wishlist-share-button-email" %}</li>
                <li class="wk-sharing__list-item">{% include "wishlist-share-button-link" %}</li>
                <li class="wk-sharing__list-item">{% include "wishlist-share-button-whatsapp" %}</li>
                {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-contact" %}</li>{% endcomment %}
              </ul>
              <div class="wk-sharing__link wk-sharing__link--hidden"><span class="wk-sharing__link-text"></span><button class="wk-sharing__link__copy-button" data-clipboard-target=".wk-sharing__link-text">{{ locale.copy_share_link }}</button></div>
            </div>
          {% endunless %}
        {% endif %}
        </div>
      `,
    },
    {
      id: "wishlist-product-form",
      events: {
        "render .wk-product-form": (form) => {
          const container = form.closest("[data-wk-item]");
          const itemId = container.getAttribute("data-wk-item");
          WishlistKing.toolkit.getItem(itemId).then((product) => {
            WishlistKing.toolkit.initProductForm(form, product, {
              // NOTE: Uncomment to override default option change
              // onOptionChange: (event) => {
              //   console.log(event.dataset);
              // },
              // NOTE: Uncomment to override default form submit
              // onFormSubmit: (event) => {
              //   event.preventDefault();
              //   event.stopPropagation();
              // },
            });
          });
        },
      },
      template: `
        <form class="wk-product-form" action="/cart/add" method="post">
          {% assign current_variant = product.selected_or_first_available_variant %}
          <div class="wk-product-form__options">
            <input name="id" value="{{ current_variant.id }}" type="hidden">
            {% unless product.has_only_default_variant %}
              {% for option in product.options_with_values %}
                <div class="wk-product-form__option">
                  <label class="wk-product-form__option__label" for="Option{{ option.position }}">
                    {{ option.name }}
                  </label>
                  <select class="wk-product-form__option__select" name="options[{{ option.name | escape }}]">
                    {% for value in option.values %}
                      <option value="{{ value | escape }}" {% if option.selected_value == value %}selected="selected"{% endif %} {% if option.soldout_values contains value %}disabled{% endif %}>
                        {{ value }}
                      </option>
                    {% endfor %}
                  </select>
                </div>
              {% endfor %}
            {% endunless %}
            {% comment %}
            <div class="wk-product-form__quantity">
              <label class="wk-product-form__quantity__label" for="Quantity">{{ locale.quantity }}</label>
              <input class="wk-product-form__quantity__input" type="number" name="quantity" value="1" min="1">
            </div>
            {% endcomment %}
          </div>
          <button type="submit" class="wk-product-form__submit" data-wk-add-to-cart="{{ product.wishlist_item_id }}" {% unless current_variant.available %}disabled{% endunless %}>
            {% if current_variant.available %}{{ locale.add_to_cart }}{% else %}{{ locale.sold_out }}{% endif %}
          </button>
        </form>
      `,
    },
    {
      id: "wishlist-page-shared",
      data: "shared_wishlist",
      template: `
        {% assign wishlist = shared_wishlist %}
        {% include "wishlist-page" with wishlist %}
      `,
    },
    {
      id: "wishlist-button-bulk-add-to-cart",
      data: "wishlist",
      events: {
        "click button[data-wk-bulk-add-to-cart]": (event) => {
          WishlistKing.toolkit.requestAddAllToCart(
            event.currentTarget.getAttribute("data-wk-bulk-add-to-cart")
          );
        },
      },
      template: `
        {% assign btn_text = locale.add_all_to_cart %}
        {% assign btn_title = locale.add_all_to_cart %}
  
        <button type="button" class="wk-button-bulk-add-to-cart" title="{{ btn_title }}" data-wk-bulk-add-to-cart="{{ wishlist.permaId }}">
          <span class="wk-label">{{ btn_text }}</span>
        </button>
      `,
    },
    {
      id: "wishlist-button-clear",
      data: "wishlist",
      events: {
        "click button[data-wk-clear-wishlist]": (event) => {
          WishlistKing.toolkit.clear(
            event.currentTarget.getAttribute("data-wk-clear-wishlist")
          );
        },
      },
      template: `
        {% assign btn_text = locale.clear_wishlist %}
        {% assign btn_title = locale.clear_wishlist %}
  
        <button type="button" class="wk-button-wishlist-clear" title="{{ btn_title }}" data-wk-clear-wishlist="{{ wishlist.permaId }}">
          <span class="wk-label">{{ btn_text }}</span>
        </button>
      `,
    },
    {
      id: "wishlist-icon",
      template: `
        <svg class="wishlist-on" version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="924.000000pt" height="875.000000pt" viewBox="0 0 924.000000 875.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,875.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M3000 6665 c-172 -37 -328 -106 -465 -204 -44 -32 -108 -76 -141 -99
        -97 -65 -184 -158 -281 -302 -45 -67 -133 -216 -133 -226 0 -2 -14 -34 -31
        -71 -52 -114 -104 -282 -139 -455 -31 -153 -30 -510 1 -668 26 -133 63 -268
        89 -325 5 -11 21 -49 36 -85 41 -96 128 -237 207 -337 38 -48 80 -104 92 -124
        13 -20 126 -130 251 -245 126 -115 273 -251 327 -302 55 -50 106 -92 113 -92
        13 0 14 3 34 85 6 28 15 66 20 85 9 34 56 232 86 360 9 36 22 88 30 115 7 28
        34 136 59 240 25 105 50 206 55 225 5 19 25 103 45 185 19 83 40 166 45 185 5
        19 37 148 70 285 33 138 65 266 70 285 5 19 30 118 54 220 80 330 186 764 196
        800 23 86 79 328 82 353 4 34 -16 46 -117 76 -149 43 -213 51 -410 50 -107 -1
        -214 -7 -245 -14z"/>
        <path d="M5695 6670 c-16 -5 -61 -16 -100 -25 -313 -75 -638 -267 -903 -533
        -51 -51 -97 -92 -102 -90 -4 2 -63 57 -131 122 l-122 119 -19 -22 c-10 -13
        -18 -32 -18 -42 0 -10 -9 -53 -20 -96 -11 -43 -63 -253 -115 -468 -52 -214
        -99 -406 -105 -425 -18 -68 -60 -238 -105 -425 -25 -104 -50 -206 -55 -225 -5
        -19 -41 -165 -80 -325 -39 -159 -75 -306 -80 -325 -5 -19 -21 -80 -34 -135
        -14 -55 -39 -156 -56 -225 -18 -69 -36 -143 -41 -165 -4 -22 -45 -184 -90
        -360 -44 -176 -83 -329 -86 -340 -6 -26 -25 -7 312 -315 99 -91 182 -167 185
        -170 3 -3 55 -50 115 -105 61 -55 137 -125 170 -156 86 -80 143 -129 201 -175
        27 -21 66 -57 85 -79 48 -57 60 -64 96 -65 26 0 39 8 64 40 18 22 67 68 108
        102 42 34 148 128 235 208 87 80 191 174 230 209 39 35 121 110 181 166 100
        93 303 279 430 393 28 25 82 75 120 111 39 36 93 86 120 111 84 76 410 374
        415 380 3 3 55 50 115 105 61 55 137 126 170 157 33 31 72 66 86 77 27 21 209
        254 268 344 74 113 162 311 199 452 48 179 62 295 62 501 0 255 -23 392 -107
        644 -106 316 -324 633 -517 756 -33 20 -80 52 -104 71 -122 93 -281 167 -445
        207 -96 24 -122 26 -303 25 -110 -1 -212 -5 -229 -9z"/>
        </g>
        </svg>
        <svg class="wishlist-off" version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="1052.000000pt" height="1018.000000pt" viewBox="0 0 1052.000000 1018.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,1018.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M3615 7798 c-198 -36 -297 -69 -470 -154 -126 -62 -282 -166 -375
        -248 -142 -126 -297 -307 -403 -472 -40 -61 -98 -183 -142 -294 -41 -106 -79
        -209 -86 -235 -68 -257 -69 -259 -69 -478 0 -194 4 -248 31 -417 25 -152 35
        -195 64 -270 9 -25 19 -57 22 -73 3 -15 9 -30 14 -33 5 -3 9 -12 9 -21 0 -14
        20 -60 83 -193 40 -84 137 -235 237 -370 39 -52 81 -111 94 -130 40 -59 263
        -308 351 -390 56 -53 299 -270 384 -342 30 -27 58 -45 62 -40 4 4 21 63 38
        132 18 69 46 177 62 240 17 63 36 147 44 185 17 85 28 131 50 210 9 33 34 128
        55 210 21 83 46 177 55 210 9 33 21 76 25 95 4 19 16 62 25 95 9 33 37 139 62
        235 24 96 54 209 65 250 11 41 23 91 27 110 5 19 21 80 36 135 15 55 31 116
        35 135 5 19 20 78 34 130 13 52 38 147 55 210 16 63 37 142 46 175 9 33 21 76
        25 95 5 19 20 80 35 135 36 135 85 341 102 425 3 14 20 75 38 135 19 61 42
        137 50 170 23 83 31 111 50 175 33 111 35 130 11 144 -57 36 -216 84 -381 117
        -109 21 -355 25 -450 7z m205 -526 c0 -10 -7 -41 -15 -68 -8 -27 -21 -75 -30
        -106 -8 -32 -22 -84 -31 -115 -8 -32 -31 -119 -51 -193 -19 -74 -39 -151 -45
        -170 -5 -19 -13 -51 -18 -70 -4 -19 -16 -62 -25 -95 -9 -33 -34 -127 -55 -210
        -21 -82 -46 -177 -55 -210 -9 -33 -21 -76 -25 -95 -4 -19 -15 -62 -25 -95 -44
        -160 -58 -213 -65 -245 -4 -19 -16 -62 -25 -95 -9 -33 -25 -91 -35 -130 -11
        -38 -31 -115 -45 -170 -15 -55 -30 -116 -35 -135 -4 -19 -15 -62 -25 -95 -43
        -157 -58 -213 -65 -245 -14 -57 -22 -80 -29 -80 -16 0 -106 115 -244 311 -94
        133 -197 360 -231 509 -38 163 -61 404 -51 525 10 116 68 321 130 460 13 28
        33 75 46 105 48 114 151 253 287 388 216 213 463 329 725 340 30 2 37 -2 37
        -16z"/>
        <path d="M6250 7799 c-209 -43 -352 -89 -504 -165 -185 -92 -350 -212 -525
        -382 -41 -40 -76 -72 -79 -72 -2 0 -47 41 -101 91 -122 116 -257 222 -275 216
        -7 -3 -19 -27 -25 -54 -7 -26 -16 -59 -21 -73 -4 -14 -13 -45 -20 -70 -7 -25
        -16 -56 -20 -70 -5 -14 -16 -52 -25 -85 -9 -33 -34 -114 -56 -180 -47 -141
        -86 -272 -100 -335 -14 -61 -23 -98 -54 -215 -25 -95 -33 -125 -54 -212 -5
        -21 -21 -83 -36 -138 -15 -55 -30 -116 -35 -135 -4 -19 -36 -143 -70 -275 -34
        -132 -66 -256 -70 -275 -5 -19 -25 -98 -45 -175 -20 -77 -40 -156 -45 -175 -4
        -19 -20 -80 -35 -135 -26 -98 -38 -144 -54 -215 -4 -19 -18 -73 -30 -120 -12
        -47 -27 -103 -32 -125 -6 -22 -14 -53 -19 -70 -5 -16 -14 -64 -20 -105 -12
        -84 -23 -134 -82 -365 -45 -181 -54 -218 -64 -260 -3 -16 -17 -69 -30 -117
        -37 -135 -42 -124 106 -253 46 -40 214 -190 320 -286 513 -465 857 -759 887
        -759 5 0 24 -18 42 -40 43 -53 78 -54 123 -4 18 20 45 42 60 50 14 7 32 19 40
        27 7 7 29 24 48 37 28 20 262 220 280 240 3 3 43 39 90 80 47 41 87 77 90 80
        3 3 68 62 145 131 377 336 520 464 525 469 3 3 43 39 90 80 47 41 108 96 135
        121 28 26 68 62 90 80 22 19 42 36 45 39 3 3 70 64 150 135 80 71 163 147 186
        167 22 21 57 51 77 66 42 31 305 315 382 412 74 94 212 288 268 378 54 87 147
        275 170 342 9 25 29 83 45 130 16 47 35 112 42 145 6 33 16 80 22 105 28 129
        47 549 28 645 -12 61 -33 149 -52 220 -17 64 -95 278 -126 345 -11 25 -36 80
        -56 123 -84 185 -308 458 -511 621 -243 196 -478 305 -780 361 -89 17 -360 19
        -435 4z m275 -509 c290 -39 480 -131 704 -345 94 -90 233 -275 272 -362 17
        -37 36 -81 44 -98 45 -100 99 -260 126 -373 30 -131 21 -373 -23 -592 -26
        -132 -108 -342 -180 -460 -89 -147 -254 -367 -357 -476 -47 -50 -108 -116
        -136 -146 -27 -29 -70 -71 -95 -93 -85 -76 -335 -300 -375 -336 -22 -20 -89
        -80 -150 -134 -60 -54 -153 -137 -205 -185 -52 -48 -113 -102 -135 -121 -22
        -19 -49 -43 -61 -54 -20 -20 -70 -65 -290 -261 -173 -155 -371 -333 -461 -416
        -29 -27 -56 -48 -61 -48 -4 0 -17 8 -28 18 -10 9 -131 118 -269 242 -137 124
        -268 241 -290 261 -22 20 -92 82 -155 139 -63 57 -119 111 -124 121 -8 17 -6
        31 24 134 4 17 16 57 25 90 9 33 25 94 37 135 11 41 24 91 28 110 4 19 20 80
        35 135 15 55 31 116 35 135 5 19 16 62 25 95 24 88 106 404 116 448 15 65 27
        109 54 212 15 55 31 117 36 138 5 20 13 54 18 75 5 20 21 82 36 137 15 55 30
        116 35 135 4 19 36 143 70 275 34 132 66 256 70 275 5 19 25 98 45 175 21 77
        40 155 42 173 7 45 25 40 67 -18 28 -39 42 -50 63 -50 16 0 33 4 39 8 5 4 46
        58 90 121 342 491 670 725 1089 779 39 5 75 10 80 11 6 0 46 -4 90 -9z"/>
        </g>
        </svg>
      `,
    },
    {
      id: "remove-icon",
      template: `
        <svg class="wk-icon__svg" width="100%" height="100%" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <path vector-effect="non-scaling-stroke" d="M0.309,0.309a0.9,0.9,0,0,1,1.268,0L63.691,62.423a0.9,0.9,0,0,1-1.268,1.268L0.309,1.577A0.9,0.9,0,0,1,.309.309Z"/>
          <path vector-effect="non-scaling-stroke" d="M63.691,0.309a0.9,0.9,0,0,1,0,1.268L1.577,63.691A0.9,0.9,0,0,1,.309,62.423L62.423,0.309A0.9,0.9,0,0,1,63.691.309Z"/>
        </svg>
      `,
    },
    {
      id: "wishlist-share-button-fb",
      data: "wishlist",
      template: `
        <a href="#" class="wk-share-button" title="{{ locale.share_on_facebook }}" data-wk-share-service="facebook" data-wk-share="{{ wishlist.permaId }}">
          <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
            <path fill="currentColor" d="M18.768,7.465H14.5V5.56c0-0.896,0.594-1.105,1.012-1.105s2.988,0,2.988,0V0.513L14.171,0.5C10.244,0.5,9.5,3.438,9.5,5.32 v2.145h-3v4h3c0,5.212,0,12,0,12h5c0,0,0-6.85,0-12h3.851L18.768,7.465z"/>
          </svg>
        </a>
      `,
    },
    {
      id: "wishlist-share-button-twitter",
      data: "wishlist",
      template: `
        <a href="#" class="wk-share-button" title="{{ locale.share_on_twitter }}" data-wk-share-service="twitter" data-wk-share="{{ wishlist.permaId }}">
          <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
          <path fill="currentColor" d="M23.444,4.834c-0.814,0.363-1.5,0.375-2.228,0.016c0.938-0.562,0.981-0.957,1.32-2.019c-0.878,0.521-1.851,0.9-2.886,1.104 C18.823,3.053,17.642,2.5,16.335,2.5c-2.51,0-4.544,2.036-4.544,4.544c0,0.356,0.04,0.703,0.117,1.036 C8.132,7.891,4.783,6.082,2.542,3.332C2.151,4.003,1.927,4.784,1.927,5.617c0,1.577,0.803,2.967,2.021,3.782 C3.203,9.375,2.503,9.171,1.891,8.831C1.89,8.85,1.89,8.868,1.89,8.888c0,2.202,1.566,4.038,3.646,4.456 c-0.666,0.181-1.368,0.209-2.053,0.079c0.579,1.804,2.257,3.118,4.245,3.155C5.783,18.102,3.372,18.737,1,18.459 C3.012,19.748,5.399,20.5,7.966,20.5c8.358,0,12.928-6.924,12.928-12.929c0-0.198-0.003-0.393-0.012-0.588 C21.769,6.343,22.835,5.746,23.444,4.834z"/>
          </svg>
        </a>
      `,
    },
    {
      id: "wishlist-share-button-whatsapp",
      data: "wishlist",
      template: `
        <a href="#" class="wk-share-button" title="{{ locale.share_with_whatsapp }}" data-wk-share-service="whatsapp" data-wk-share="{{ wishlist.permaId }}">
          <svg xmlns="https://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
            <path fill="currentColor" stroke="none" d="M20.1,3.9C17.9,1.7,15,0.5,12,0.5C5.8,0.5,0.7,5.6,0.7,11.9c0,2,0.5,3.9,1.5,5.6l-1.6,5.9l6-1.6c1.6,0.9,3.5,1.3,5.4,1.3l0,0l0,0c6.3,0,11.4-5.1,11.4-11.4C23.3,8.9,22.2,6,20.1,3.9z M12,21.4L12,21.4c-1.7,0-3.3-0.5-4.8-1.3l-0.4-0.2l-3.5,1l1-3.4L4,17c-1-1.5-1.4-3.2-1.4-5.1c0-5.2,4.2-9.4,9.4-9.4c2.5,0,4.9,1,6.7,2.8c1.8,1.8,2.8,4.2,2.8,6.7C21.4,17.2,17.2,21.4,12,21.4z M17.1,14.3c-0.3-0.1-1.7-0.9-1.9-1c-0.3-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.8,1-0.9,1.1c-0.2,0.2-0.3,0.2-0.6,0.1c-0.3-0.1-1.2-0.5-2.3-1.4c-0.9-0.8-1.4-1.7-1.6-2c-0.2-0.3,0-0.5,0.1-0.6s0.3-0.3,0.4-0.5c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0-0.4,0-0.5c0-0.1-0.7-1.5-1-2.1C8.9,6.6,8.6,6.7,8.5,6.7c-0.2,0-0.4,0-0.6,0S7.5,6.8,7.2,7c-0.3,0.3-1,1-1,2.4s1,2.8,1.1,3c0.1,0.2,2,3.1,4.9,4.3c0.7,0.3,1.2,0.5,1.6,0.6c0.7,0.2,1.3,0.2,1.8,0.1c0.6-0.1,1.7-0.7,1.9-1.3c0.2-0.7,0.2-1.2,0.2-1.3C17.6,14.5,17.4,14.4,17.1,14.3z"/>
          </svg>
        </a>
      `,
    },
    {
      id: "wishlist-share-button-email",
      data: "wishlist",
      template: `
        <a href="#" class="wk-share-button" title="{{ locale.share_by_email }}" data-wk-share-service="email" data-wk-share="{{ wishlist.permaId }}">
          <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24"">
            <path fill="currentColor" d="M22,4H2C0.897,4,0,4.897,0,6v12c0,1.103,0.897,2,2,2h20c1.103,0,2-0.897,2-2V6C24,4.897,23.103,4,22,4z M7.248,14.434 l-3.5,2C3.67,16.479,3.584,16.5,3.5,16.5c-0.174,0-0.342-0.09-0.435-0.252c-0.137-0.239-0.054-0.545,0.186-0.682l3.5-2 c0.24-0.137,0.545-0.054,0.682,0.186C7.571,13.992,7.488,14.297,7.248,14.434z M12,14.5c-0.094,0-0.189-0.026-0.271-0.08l-8.5-5.5 C2.997,8.77,2.93,8.46,3.081,8.229c0.15-0.23,0.459-0.298,0.691-0.147L12,13.405l8.229-5.324c0.232-0.15,0.542-0.084,0.691,0.147 c0.15,0.232,0.083,0.542-0.148,0.691l-8.5,5.5C12.189,14.474,12.095,14.5,12,14.5z M20.934,16.248 C20.842,16.41,20.673,16.5,20.5,16.5c-0.084,0-0.169-0.021-0.248-0.065l-3.5-2c-0.24-0.137-0.323-0.442-0.186-0.682 s0.443-0.322,0.682-0.186l3.5,2C20.988,15.703,21.071,16.009,20.934,16.248z"/>
          </svg>
        </a>
      `,
    },
    {
      id: "wishlist-share-button-link",
      data: "wishlist",
      template: `
        <a href="#" class="wk-share-button" title="{{ locale.get_link }}" data-wk-share-service="link" data-wk-share="{{ wishlist.permaId }}">
          <svg xmlns='https://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 512 512'>
            <path fill="currentColor" d='M459.654,233.373l-90.531,90.5c-49.969,50-131.031,50-181,0c-7.875-7.844-14.031-16.688-19.438-25.813
              l42.063-42.063c2-2.016,4.469-3.172,6.828-4.531c2.906,9.938,7.984,19.344,15.797,27.156c24.953,24.969,65.563,24.938,90.5,0
              l90.5-90.5c24.969-24.969,24.969-65.563,0-90.516c-24.938-24.953-65.531-24.953-90.5,0l-32.188,32.219
              c-26.109-10.172-54.25-12.906-81.641-8.891l68.578-68.578c50-49.984,131.031-49.984,181.031,0
              C509.623,102.342,509.623,183.389,459.654,233.373z M220.326,382.186l-32.203,32.219c-24.953,24.938-65.563,24.938-90.516,0
              c-24.953-24.969-24.953-65.563,0-90.531l90.516-90.5c24.969-24.969,65.547-24.969,90.5,0c7.797,7.797,12.875,17.203,15.813,27.125
              c2.375-1.375,4.813-2.5,6.813-4.5l42.063-42.047c-5.375-9.156-11.563-17.969-19.438-25.828c-49.969-49.984-131.031-49.984-181.016,0
              l-90.5,90.5c-49.984,50-49.984,131.031,0,181.031c49.984,49.969,131.031,49.969,181.016,0l68.594-68.594
              C274.561,395.092,246.42,392.342,220.326,382.186z'/>
          </svg>
        </a>
      `,
    },
    {
      id: "wishlist-share-button-contact",
      data: "wishlist",
      template: `
        <a href="#" class="wk-share-button" title="{{ locale.send_to_customer_service }}" data-wk-share-service="contact" data-wk-share="{{ wishlist.permaId }}">
          <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
          </svg>
        </a>
      `,
    },
  ];
  
  export default templates;